import { getFontSize } from '../../../../../constants/fontSizes';

export const mobileSidebarStyles = (isOpen) => {
  return {
    drawerPaper: {
      width: '100vw',
      backgroundColor: 'secondary.main',
    },
    sidebar: {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
      overflowY: 'auto',
      height: '100vh',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '60px',
    },
    closeButton: {
      padding: 0,
      color: '#1F1F1F',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    closeIcon: {
      fontSize: getFontSize(30),
    },
    navContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '40px',
      flex: 1,
    },
    navLink: {
      fontFamily: 'Aurora',
      fontWeight: 400,
      fontSize: "30px",
      lineHeight: '24px',
      letterSpacing: '0%',
      color: '#1F1F1F',
      textDecoration: 'none',
      '&:hover': {
        opacity: 0.7,
      },
    },
    navLinkActive: {
      fontWeight: 700,
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      width: '100%',
      marginTop: 'auto',
      paddingTop: '40px',
    },
    signInButton: {
      textTransform: 'none',
      borderColor: 'primary.main',
      color: 'primary.main',
      borderRadius: '52px',
      padding: '15px 40px',
      fontSize: 18,
      fontWeight: 400,
      '&:hover': {
        borderColor: 'primary.dark',
        backgroundColor: 'transparent',
      },
    },
    bookStayButton: {
      textTransform: 'none',
      backgroundColor: 'primary.main',
      color: 'secondary.main',
      borderRadius: '52px',
      padding: '15px 20px',
      fontSize: 18,
      fontWeight: 400,
      '&:hover': {
        backgroundColor: 'primary.dark',
      },
    },
  };
};

